// SET ADVANCED_CATEGORIES IN THE ORDER YOU WANT THEM TO RENDER
export const ADVANCED_CATEGORIES = {
  APPEARANCE: 'Appearance',
  AMOUNT: 'Amount',
  RECEIPT: 'Receipt',
  OTHERS: 'Others'
}

export const environments = {
  PRODUCTION: 'production',
  TEST: 'test',
  DEVELOPMENT: 'development'
}

export const modes = {
  GAMBLING: 'gambling',
  ECOMMERCE: 'ecommerce',
  ACCOUNT_VERIFICATION: 'accountVerification'
}

export const amountDisplayStyle = {
  SYMBOL: 'symbol',
  ISO: 'ISO-3'
}

export const redirectUrlStatuses = {
  PENDING: 'pending',
  FAILED: 'failed',
  FAILURE: 'failure',
  CANCEL: 'cancel'
}

export const amountTransactionStyle = {
  TXAMOUNT: 'TxAmount',
  AMOUNT: 'Amount'
}

export const cashierStyles = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
}

export const PIQ_CONTAINERS = {
  WINDOW: 'window',
  IFRAME: 'iframe'
}

export const displayAccounts = {
  LIST_FIRST: 'list-first',
  LIST_WITH_PM: 'list-with-pm',
  INLINE: 'inline',
  FALSE: false
}

export const scrollSettings = {
  NONE: null,
  CENTER: 'center',
  START: 'start',
  END: 'end',
  NEAREST: 'nearest'
}

export const TX_STATUS = {
  SUCCESSFUL: 'successful',
  FAILED: 'failed',
  WAITING_INPUT: 'waiting_input'
}

export const methods = {
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal'
}

export const txTypes = {
  DEPOSIT: 'CreditcardDeposit',
  WITHDRAWAL: 'CreditcardWithdrawal'
}

export const txStates = {
  WAITING_INPUT: 'WAITING_INPUT',
  SUCCESSFUL: 'SUCCESSFUL',
  WAITING_APPROVAL: 'WAITING_APPROVAL',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  INCONSISTENT: 'INCONSISTENT',
  PROCESSING: 'PROCESSING'
}

// We need some internal status for when status-request fails or when we don't get an updated status after the set number of retries
export const internalTxStatuses = {
  FAILED_TO_GET_TX_STATUS: 'FAILED_TO_GET_TX_STATUS',
  WAITING_INPUT_PENDING_WITHOUT_SUCCESS:
    'WAITING_INPUT_PENDING_WITHOUT_SUCCESS',
  TRANSACTION_STATUS_POLL_LIMIT_REACHED: 'TRANSACTION_STATUS_POLL_LIMIT_REACHED'
}

export const providerTypes = {
  CREDITCARD: 'CREDITCARD',
  CREDITCARD_SAVED: 'creditcard',
  NETELLER: 'neteller'
}

export const inputTypes = {
  AMOUNT: 'AMOUNT',
  NUMBER: 'NUMBER',
  CREDITCARD_NUMBER: 'CREDITCARD_NUMBER',
  CVV: 'CVV',
  EXPIRY_MM_YYYY: 'EXPIRY_MM_YYYY',
  HIDDEN: 'HIDDEN'
}

export const InputAttributes = {
  _Number_: {
    type: 'number', // only allow numbers
    pattern: '[0-9]*' // triggers numpad on mobile
  },
  _CreditCard_: {
    name: 'cardnumber',
    id: 'frmCCNum',
    required: true,
    autocomplete: 'cc-number',
    showIcon: true
  },
  _CVV_: {
    name: 'cvc',
    id: 'frmCCCVC',
    required: true,
    autocomplete: 'cc-csc',
    showIcon: true,
    type: 'number',
    pattern: '[0-9]*'
  },
  _EXPIRY_MM_YYYY_: {
    name: 'cc-exp',
    id: 'frmCCExp',
    required: true,
    placeholder: 'MM-YYYY',
    autocomplete: 'cc-exp',
    showIcon: true,
    type: 'number',
    pattern: '[0-9]*'
  },
  _EMAIL_: {
    type: 'email',
    pattern: '.+@globex.com"',
    inputmode: 'email',
    size: 30
  },
  _TELEPHONE_: {
    type: 'tel',
    name: 'phone_num',
    pattern: '[0-9]*',
    inputmode: 'tel',
    size: 20
  },
  _HIDDEN_: {
    type: 'hidden'
  }
}

export const CVV_FIELD = {
  attribute: false,
  country: null,
  errorKey: null,
  extend: null,
  helpKey: 'creditcard.main.cvc',
  hosted: true,
  id: 'cvv',
  key: 'creditcard.main.cvc',
  market: null,
  name: 'cvv',
  pattern: null,
  requiredNewPayment: true,
  requiredRepeatPayment: true,
  size: 0,
  type: 'CVV',
  val: null,
  visibleOnNewPayment: true,
  visibleOnRepeatPayment: true
}

export const FEE_TYPES = {
  PERCENTAGE: 'percentageFee',
  FIXED: 'fixedFee',
  FIXED_MAX: 'fixedFeeMax',
  FIXED_MIN: 'fixedFeeMin'
}

export const RENDER_LIST_TYPES = {
  LIST: 'list',
  GRID: 'grid'
}

export const RENDER_LOGO_OR_NAME = {
  BOTH: 'both',
  LOGO: 'logo',
  NAME: 'name'
}
